import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';

const Sites = () => {

    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();
  
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    let response71 = useInvoke("WebApps", "71", {});

    const[rows, setRows] = useState([]);
    const[columns, setColumns] = useState([]);

    let toastLoading = "";

    useEffect(() => {
        toastLoading = toast.loading('Loading...');
    }, []);

    useEffect(() => {

        //get sites
        if (response71.data.payload != undefined) {

            toast.dismiss(toastLoading);

            let myData = JSON.parse(response71.data.payload).data;
            let rowsList = [];

            myData.forEach((entry, index) => { 

              let row = [
                {type: "text", content: {text: `${entry[1]}`}},
                {type: "link", content: {text: `${entry[2]}`, link: `/Sites/Edit/${entry[0]}`}}, 
                {type: "text", content: {text: `${entry[3]}`}},
                {type: "text", content: {text: `${entry[4]}`}},
                {type: "text", content: {text: `${entry[5]}`}},
                {type: "text", content: {text: `${entry[6]}`}},
              ];
              rowsList.push(row);
            });
            setColumns(["Customer", "Name", "Address", "City", "State", "Zip"]);
            setRows(rowsList);
        }

    }, [response71.data.payload]);


    document.title = "Sites";
    return (  
        <div className="sites">
            {user["email"] != undefined && 
                <>
                    <div className="container" style={{margin: "auto"}}>
                        <h2>Sites</h2>
                    
                        {(columns && rows) && <DynamicGrid columnNames={columns} tableData={rows} sortable={true} />}

                    </div>
                </>
            }
            
        </div>
    );
}
 
export default Sites;